<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="项目名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.projectName"
              placeholder="请输入项目名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="省市区：" class="input-with-col2">
            <AddreassSelect
              :isSearch="true"
              :warning="addressWarn"
              :showDetailAddress="showDetailAddress"
              :addressName="addressName"
              @change="setPojectAddress"
            ></AddreassSelect>
          </el-form-item>
          <el-form-item label="使用单位：">
            <el-select
              size="mini"
              v-model="form.propertyUnitId"
              filterable
              placeholder="请选择使用单位"
              clearable
              reserve-keyword
              :remote="true"
              @change="handleSearchListData"
              :remote-method="searchUnitList"
              @visible-change="searchUnitList('')"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.unitName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          v-if="hasRole['XMGLTJ']"
          size="mini"
          type="primary"
          class="plr28"
          @click="handleAdd"
          >添加</el-button
        >
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
          v-if="hasRole['XMGLSC']"
          >删除</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="exportProject"
          plain
          class="plr28"
          v-if="hasRole['XMGLDC']"
          >导出</el-button
        >
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="项目名称"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="creditCode"
            label="省市区街道"
            width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.provinceName }}
              {{ scope.row.cityName }}
              {{ scope.row.districtName }}
              {{ scope.row.address }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="propertyUnitName"
            label="使用单位"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contactTelephone"
            label="联系电话"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="liftNum"
            label="电梯数量"
            width="100"
          ></el-table-column>
            <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="创建时间"
            width="100"
          ></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="hasRole['XMGLBJ']"
                type="text"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <div class="btn-divide" v-if="hasRole['XMGLBJ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['XMGLSC']"
                type="text"
                @click="handleDeleteUnit(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-project
      v-if="addProjectVisible"
      @cancel="addProjectVisible = false"
      @confirm="handleAddProjectConfirm"
    ></add-project>
    <edit-project
      v-if="editProjectVisible"
      :editData="projectDetail"
      @cancel="editProjectVisible = false"
      @confirm="handleEditProjectConfirm"
    ></edit-project>
    <check-project
      v-if="checkProjectVisible"
      :editData="projectDetail"
      @cancel="checkProjectVisible = false"
    ></check-project>
    <check-department
      v-if="checkDepartment"
      :editData="projectDetail"
      @cancel="checkDepartment = false"
    ></check-department>
  </div>
</template>

<script>
import {
  getProjectList,
  deleteProject,
  exportProject,
  getUnitSimpleList,
} from "@/api/ProjectManagement";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";
import AddProject from "./components/AddProject";
import EditProject from "./components/EditProject";
import CheckProject from "./components/CheckProject";
import CheckDepartment from "./components/CheckDepartment";
export default {
  name: "ProjectManagement",
  components: {
    AddProject,
    EditProject,
    CheckProject,
    CheckDepartment,
    AddreassSelect,
  },
  data() {
    return {
      form: {
        projectName: "",
        propertyUnitId: "",
        cityCode: "",
        districtCode: "",
        provinceCode: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addProjectVisible: false,
      editProjectVisible: false,
      checkProjectVisible: false,
      checkDepartment: false,
      projectDetail: {},
      addressWarn: false,
      addressName: "项目地址",
      showDetailAddress: false,
      unitList: [],
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
    this.searchUnitList();
  },
  methods: {
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      const res = await getProjectList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteUnit(row) {
      const idList = [row.id];
      this.deleteProject(idList);
    },
    handleCheck(row) {
      this.projectDetail = row;
      this.checkDepartment = true;
    },
    handleEdit(row) {
      this.projectDetail = row;
      this.editProjectVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deleteProject(idList);
    },
    deleteProject(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteProject({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd() {
      this.addProjectVisible = true;
    },
    exportProject() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      exportProject(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddProjectConfirm() {
      this.addProjectVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditProjectConfirm() {
      this.editProjectVisible = false;
      this.getListData();
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
      this.getListData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/ProjectManagement/ProjectManagement.vue